"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Star, TrendingUp } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
const testimonials = [{
  id: 1,
  author: "5 / 5",
  position: "Infill Developer",
  quote: "\"Lorenzo's experience working with buyers insight helped us tweak our build, and sell it less than 30 days.\"",
  beforeScore: "ROI 12%",
  afterScore: "ROI 28%",
  avatarSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687293/img/developer_marcus.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687293/img/developer_marcus.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687293/img/developer_marcus.png-wvc-sizes"
}, {
  id: 2,
  author: "Tarinder P",
  position: "Luxury Home Seller",
  quote: "The precision in his valuation and the high-end marketing strategy secured a record-breaking sale for our residential estate.",
  beforeScore: "List $1.2M",
  afterScore: "Sold $1.45M",
  avatarSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687293/img/seller_elena.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687293/img/seller_elena.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687293/img/seller_elena.png-wvc-sizes"
}, {
  id: 3,
  author: "5 / 5",
  position: "Commercial Investor",
  quote: "\"Lorenzo is that rare professional, who's direct, effective, and has saved us lots of money with competitive property management prices\"",
  beforeScore: "Cap 5.2%",
  afterScore: "Cap 7.8%",
  avatarSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687293/img/investor_david.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687293/img/investor_david.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687293/img/investor_david.png-wvc-sizes"
}];
export default function VoicesOfSuccess() {
  return <section data-section-id="242339" id="voices-of-success" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-secondary/5 rounded-md blur-[150px] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16 lg:mb-24">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default tracking-tight mb-6 text-primary">
            Voices of Success
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-sans leading-relaxed">Refined perspectives from the builders, buyers, and investors who have redefined their portfolios through our value-focused real estate approach.</p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full max-w-6xl mx-auto">
          <CarouselContent className="-ml-4 md:-ml-6">
            {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/2">
                <div className="h-full flex flex-col p-8 md:p-10 rounded-md bg-card/60 backdrop-blur-xl border border-border shadow-md transition-all duration-300 hover:border-secondary/50 hover:bg-card group">
                  
                  {}
                  <div className="flex items-center gap-5 mb-8">
                    <SafeHydrate><Avatar className="w-16 h-16 border-2 border-secondary group-hover:border-secondary/80 transition-colors">
                      
                      <AvatarFallback className="bg-muted text-muted-foreground font-default text-xl">
                        {testimonial.author.charAt(0)}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    <div>
                      <h3 className="font-default font-semibold text-xl text-primary">
                        {testimonial.author}
                      </h3>
                      <p className="text-sm text-muted-foreground font-sans tracking-wider uppercase">
                        {testimonial.position}
                      </p>
                    </div>
                  </div>

                  {}
                  <div className="flex gap-1 mb-6 text-secondary font-default font-bold text-sm tracking-widest">
                    5.0 / 5.0
                  </div>

                  {}
                  <blockquote className="flex-grow mb-10">
                    <p className="text-lg md:text-xl text-foreground/90 font-serif italic leading-relaxed">
                      "{testimonial.quote}"
                    </p>
                  </blockquote>

                  {}
                  <div className="mt-auto pt-6 border-t border-border flex items-center justify-between">
                    <div className="flex flex-col gap-2">
                      
                      
                    </div>
                    
                    <div className="flex flex-col items-center justify-center px-4">
                      
                    </div>

                    <div className="flex flex-col gap-2 items-end">
                      
                      
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          {}
          <div className="flex items-center justify-center gap-4 mt-12">
            <CarouselPrevious className="static translate-y-0 translate-x-0 size-12 bg-primary text-primary-foreground border-none hover:bg-secondary hover:text-secondary-foreground transition-colors rounded-md" />
            <CarouselNext className="static translate-y-0 translate-x-0 size-12 bg-primary text-primary-foreground border-none hover:bg-secondary hover:text-secondary-foreground transition-colors rounded-md" />
          </div>
        </Carousel>
      </div>
    </section>;
}